
const digest = '1dd3d0991688a4a740149e90dcb92cb887b9c0ad0039a69e3593176f1b6b601e';
const css = `._container_zemk3_1 {
  --toc-border-color: var(--theme-primary-border);
  --toc-content-border-color: var(--theme-light-border);

  background: transparent;
  padding: var(--spacer-2);
  border-radius: var(--Common--border-radius);
  box-sizing: border-box;
  margin: var(--spacer-3);
  border-color: transparent;
  padding: 0;
  border: 0;
  overflow: hidden;
  user-select: none;
  margin-bottom: var(--spacer-3);
  color: var(--theme-tertiary-text);
  font-size: var(--aha-editor--user-font-size);

  &:hover {
    --toc-border-color: var(--theme-secondary-border);
    --toc-content-border-color: var(--theme-primary-border);

    border: 0;
  }

  /* Apply some default CSS to override browser defaults inside the TOC */
  * {
    box-sizing: border-box;
  }
}

._details_zemk3_32 {
  border: 1px solid var(--theme-primary-border);
  background-color: transparent;
  border-radius: var(--Common--border-radius);
  display: flex !important;
  flex-direction: column;

  &:hover {
    background-color: var(--theme-container-light-background);
    border: 1px solid var(--theme-primary-border);
  }

  /* Styles for top level list */
  > ._list_zemk3_45 {
    padding-left: var(--spacer-4);
    padding-bottom: var(--spacer-2);
    border: 0 !important;

    > ._listItem_zemk3_50 {
      padding: 0;
    }
  }

  &[open] {
    border: 1px solid transparent;
    padding-bottom: var(--spacer-2);
    gap: var(--spacer-3);

    ._summary_zemk3_60 {
      border-bottom: 1px solid var(--theme-light-border);
    }

    ._expansionIcon_zemk3_64 i {
      transform: rotate(90deg);
    }
  }
}

._summary_zemk3_60 {
  padding: var(--spacer-1) 0 var(--spacer-1) var(--spacer-3);
  font-size: var(--font-size-h-700);
  /* !important needed to override globals from faq.less */
  display: flex !important;
  gap: var(--spacer-2);
  align-items: center;
  list-style: none;
  flex-direction: row;

  > * {
    display: inline-block;
  }

  &::-webkit-details-marker,
  &::marker {
    display: none;
    -webkit-appearance: none;
  }

  &:hover {
    background-color: var(--theme-container-light-background);
    color: var(--theme-tertiary-text);
  }
}

._expansionIcon_zemk3_64 {
  border-radius: var(--Common--border-radius);
  cursor: pointer;
  margin-right: var(--spacer-2);

  &:hover {
    background: var(--theme-hover-background);
  }

  > i {
    transition: transform 0.2s;
  }
}

._label_zemk3_110 {
  flex: 1;
}

._list_zemk3_45 {
  padding: 0 0 0 var(--spacer-6);
  border-left: solid 1px var(--theme-light-border);
  list-style: none;
  margin: 0;
}

._listItem_zemk3_50 {
  padding: 0;
}

._showBorder_zemk3_125 {
  border-left: solid 1px var(--toc-border-color);
}

._link_zemk3_129 {
  --side-padding: var(--spacer-1);
  --left-padding: var(--spacer-2);
  padding: var(--side-padding) 0 var(--side-padding) var(--left-padding);
  margin: 0;
  margin-left: calc(var(--left-padding) * -1);
  width: 100%;
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
  border-radius: var(--Common--border-radius);

  &:hover {
    background-color: var(--theme-secondary-background);
    text-decoration: none;
    color: var(--theme-button-primary-hovered);
  }
}

._emptyState_zemk3_150 {
  text-align: center;
  margin: var(--spacer-4) var(--spacer-2);
  font-size: 1.2em;
}
`;

(function() {
  if (!document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
    
export default {"container":"_container_zemk3_1","details":"_details_zemk3_32","list":"_list_zemk3_45","listItem":"_listItem_zemk3_50","summary":"_summary_zemk3_60","expansionIcon":"_expansionIcon_zemk3_64","label":"_label_zemk3_110","showBorder":"_showBorder_zemk3_125","link":"_link_zemk3_129","emptyState":"_emptyState_zemk3_150"};
export { css, digest };
  